import React, { ReactNode } from 'react';
import styles from './ReviewerAssignment.module.scss';
import { SearchEntity, Permission, User, ReadOnlyUser } from 'v2/models';
import { PERMISSION_NAME } from 'v2/utils/permissions';
import { PermissionFlag } from 'v2/context/permissionFlagContext';
import { FeatureToggle } from 'react-feature-toggles';
import { FEATURE_FLAGS } from 'utils/constants';

interface ReviewerAssignmentProps {
  user: User;
  search: SearchEntity;
  children: ReactNode;
  permissions: { [key: string]: Permission };
}

const ReviewerAssignmentBox = ({ user }: { user: ReadOnlyUser }) => {
  return (
    <div className={styles.reviewerAssignmentBox}>
      {user.first_name} {user.last_name} is currently reviewing this request.
    </div>
  );
};

const ReviewerAssignment = ({
  user,
  search,
  children,
  permissions,
}: ReviewerAssignmentProps) => {
  return (
    <PermissionFlag
      permissions={permissions}
      namePermission={[
        PERMISSION_NAME.REVIEW_SEARCH_ORG,
        PERMISSION_NAME.REVIEW_SEARCH_MASTER_ORG,
      ]}
    >
      <FeatureToggle featureName={FEATURE_FLAGS.REVIEWER_ASSIGNMENT}>
        {search.assigned_to && user.id !== search.assigned_to.id ? (
          <ReviewerAssignmentBox
            user={search.assigned_to}
          ></ReviewerAssignmentBox>
        ) : (
          children
        )}
      </FeatureToggle>

      <FeatureToggle
        featureName={FEATURE_FLAGS.REVIEWER_ASSIGNMENT}
        showOnlyWhenDisabled
      >
        {children}
      </FeatureToggle>
    </PermissionFlag>
  );
};

export default ReviewerAssignment;
